import React, { Fragment } from "react";
import { Form, FormGroup, Label, Input } from "reactstrap";
import PropTypes from "prop-types";
import { CircularProgress } from "../../../../..";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

import { FormField } from "../../../../../utils/FormFields";

function PersonSuitability({ person, changedPerson, showChanges, remove }) {
  const showLegalAddress = changedPerson || person;
  const editLegalAddress = changedPerson.LegalAddress[0];
  let compareLegalAddress;
  person.LegalAddress.forEach((d) => {
    if (parseInt(d.LegalAddressId, 10) === parseInt(editLegalAddress.LegalAddressId, 10)) {
      compareLegalAddress = d;
    }
  });

  const showPersonSuitability = changedPerson || person;
  const editPersonSuitabilty = changedPerson.PersonQuestion;
  let comparePersonSuitability;

  let color = "black";
  if (showPersonSuitability) {
    if (compareLegalAddress === undefined) {
      color = "green";
    } else {
      color = remove ? "red" : "#36a9e1";
    }
  }
  return (
    <Form>
      {showChanges ? (
        <FormGroup tag="fieldset">
          {compareLegalAddress && (
            <FormToShow questions={changedPerson.PersonQuestion} changedQuestions={person.PersonQuestion} />
          )}
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          {compareLegalAddress && (
            <FormToShow questions={person.PersonQuestion} changedQuestions={changedPerson.PersonQuestion} />
          )}
        </FormGroup>
      )}
    </Form>
  );
}

// PhysicalPersonLegalAddress.propTypes = {
//   person: PropTypes.object.isRequired,
//   changedPerson: PropTypes.object.isRequired,
//   showChanges: PropTypes.bool.isRequired,
// };

export default PersonSuitability;

const FormToShow = ({ questions, changedQuestions }) => {
  return (
    <React.Fragment>
      {!questions ? (
        <CircularProgress sm />
      ) : (
        <div>
          {questions.length > 0 ? (
            questions.map((q, qIndex) => {
              const questionToCompare = changedQuestions.find(
                (elemento) => elemento.QuestionId == q.QuestionId
              );
              if (!compareQuestions(q.PersonAnswer, questionToCompare.PersonAnswer)) {
                return (
                  <Fragment>
                    <Form key={q.QuestionId}>
                      <FormGroup tag="fieldset">
                        <legend style={{ fontSize: "1.2rem", padding: "5px" }}>
                          {q.QuestionDescription}
                        </legend>
                        {q.PersonAnswer.map((a, aIndex) => (
                          <FormGroup check key={a.AnswerId}>
                            <Label
                              style={{ color: a.AnswerId === q.NewAnswerId ? "#36a9e1" : "black" }}
                              check
                            >
                              <Input
                                type="radio"
                                name="radio1"
                                defaultChecked={a.AnswerIsResponse}
                                value={
                                  a.AnswerIsResponse ? q.NewAnswerId === 0 : q.NewAnswerId === a.AnswerId
                                }
                                onChange={() => handleChangeAnswer(qIndex, aIndex)}
                                disabled={true}
                              />
                              {` ${a.AnswerDescription}`}
                            </Label>
                          </FormGroup>
                        ))}
                      </FormGroup>
                    </Form>
                  </Fragment>
                );
              }
            })
          ) : (
            <span style={{ textAlign: "center" }}>No Questions.</span>
          )}

          {/* {questions.length > 0 && (
            <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={loadingSave}
              disabled={!save}
              onClick={() => handleSave()}
              data-style={EXPAND_RIGHT}
            >
              Save
            </LaddaButton>
          )} */}
        </div>
      )}
    </React.Fragment>
  );
};

const compareQuestions = (question1, question2) => {
  for (let i = 0; i < question1.length; i++) {
    const obj1 = question1[i];
    const questionToCompare = question2.find((elemento) => elemento.AnswerId == obj1.AnswerId);
    // Comparar campo por campo
    if (obj1.AnswerIsResponse !== questionToCompare.AnswerIsResponse) {
      return false; // Si un campo no es igual, retornar false
    }
  }
  return true;
};

FormToShow.propTypes = {
  legalAddress: PropTypes.object.isRequired,
  refLegalAddress: PropTypes.object,
};

FormToShow.defaultProps = {
  refLegalAddress: undefined,
};
